export const SUITS = {
  D: { symbol: "♡", name: "Diamonds", unicodeBase: 0x1f0b1 },
  H: { symbol: "♢", name: "Hearts", unicodeBase: 0x1f0c1 },
  C: { symbol: "♧", name: "Clubs", unicodeBase: 0x1f0d1 },
  S: { symbol: "♤", name: "Spades", unicodeBase: 0x1f0a1 },
};
export const SUITS_KEYS: Suit[] = Object.keys(SUITS) as Suit[];
export type Suit = keyof typeof SUITS;

export const RANKS = [
  { short: "2", name: "Two" },
  { short: "3", name: "Three" },
  { short: "4", name: "Four" },
  { short: "5", name: "Five" },
  { short: "6", name: "Six" },
  { short: "7", name: "Seven" },
  { short: "8", name: "Eight" },
  { short: "9", name: "Nine" },
  { short: "T", name: "Ten" },
  { short: "J", name: "Jack" },
  { short: "Q", name: "Queen" },
  { short: "K", name: "King" },
  { short: "A", name: "Ace" },
];
export const RANKS_KEYS = RANKS.map((_, i) => i);
export const RANK_2 = 0;
export const RANK_3 = 1;
export const RANK_4 = 2;
export const RANK_5 = 3;
export const RANK_6 = 4;
export const RANK_7 = 5;
export const RANK_8 = 6;
export const RANK_9 = 7;
export const RANK_T = 8;
export const RANK_J = 9;
export const RANK_Q = 10;
export const RANK_K = 11;
export const RANK_A = 12;
export type Rank = number;

export type CardType = {
  suit: "D" | "C" | "H" | "S";
  rank: number;
};
